import React, { Component } from 'react';
import { Container, Div, CommentContainer, InputContainer } from './CommentArea.style';
import Comment from './Comment/Comment';
import InputArea from '../MoveTemplate/InputArea/InputArea'
import i18n from '../../i18n';
class CommentArea extends Component {

    commentAreaRef;
    isDown = false;
    startY;
    scrollTop

    setCommentAreaRef = ref => {
        if (!ref) return
        this.commentAreaRef = ref

        this.commentAreaRef.addEventListener('mousedown', (e) => {
            this.isDown = true;
            this.startY = e.pageY - this.commentAreaRef.offsetTop;
            this.scrollTop = this.commentAreaRef.scrollTop;
            this.forceUpdate()
        });
        this.commentAreaRef.addEventListener('mouseleave', () => {
            this.isDown = false;
        });
        this.commentAreaRef.addEventListener('mouseup', () => {
            this.isDown = false;
        });
        this.commentAreaRef.addEventListener('mousemove', (e) => {
            if (!this.isDown) return;
            e.preventDefault();
            const y = e.pageY - this.commentAreaRef.offsetTop;
            const walk = (y - this.startY) * 1; //scroll-fast
            this.commentAreaRef.scrollTop = this.scrollTop - walk;
            this.forceUpdate()
        });

        this.props.setCommentArea(ref)
    }

    render() {
        let { 
            commentList, 
            currentUser, 
            onRemove, 
            onModify, 
            onReport, 
            onCommentCancel, 
            onCommnetConfrim, 
            changeModityTextInput, 
            selectedComment,
            isModify,
            setCommentArea,
            modifyComment,
            onClickNickname,

            inputDisable,
            setFocus,
            onInputClick,
            onInputChange,
            textValue
        } = this.props
        
        return (
            <Container ref={this.setCommentAreaRef} id={"commentArea"}>
                <CommentContainer>
                    { // 댓글 목록
                        (Array.isArray(commentList) && commentList.length > 0) ?
                            commentList.map((item, index) => {
                                return (
                                    <Comment
                                        isModify={isModify}
                                        commentInfo={item}
                                        key={index}
                                        currentUser={currentUser}
                                        onRemove={onRemove}
                                        onModify={onModify}
                                        onCommentCancel={onCommentCancel}
                                        onCommnetConfrim={onCommnetConfrim}
                                        onReport={onReport}
                                        selectedComment={selectedComment}
                                        changeModityTextInput={changeModityTextInput}
                                        modifyComment={modifyComment}
                                        onClickNickname={onClickNickname}
                                    />
                                )
                            })
                            :

                            <Div justifyContent={"center"}>
                                {i18n.t("web.shared.empty.comment")}
                            </Div>
                    }
                </CommentContainer>
                <InputContainer>
                { // 댓글 입력창
                    !inputDisable
                    &&
                    <InputArea
                        setFocus={setFocus}
                        setInputRef={() => {}}
                        onClick={onInputClick}
                        onChange={onInputChange}
                        textValue={textValue}
                    />
                }
                </InputContainer>
            </Container>
        );
    }
}

export default CommentArea;